<mat-slide-toggle [(ngModel)]="showToolbarActionsAlwaysAsMenu" (click)="triggerShowToolbarActionsAlwaysAsMenu()"
  >Show toolbar actions as burger menu
</mat-slide-toggle>
<br />
<br />
<mad-toolbar></mad-toolbar>
